import React from 'react';
import OpenInNew from '@mui/icons-material/OpenInNew';
import { Button } from '@mui/material';
import { getSalesforceContactLink } from '../../../utils/helpers';
import { getExpenseProviderSalesforceId } from '../../Utils/ExpenseUtil';

export default function ExpenseSalesforceActionButton({
    assignment,
    expense,
    originalClinicianId,
    className,
}) {
    if (assignment?.sfLink) {
        return (
            <Button
                variant="outlined"
                color="primary"
                href={assignment.sfLink}
                target="_blank"
                rel="noopener noreferrer"
                endIcon={<OpenInNew />}
                className={className}
                data-testid="expense-view-booking-button"
            >
                View booking
            </Button>
        );
    }

    const providerSalesforceId = getExpenseProviderSalesforceId(expense, { originalClinicianId });
    if (!providerSalesforceId) {
        return null;
    }

    return (
        <Button
            variant="outlined"
            color="primary"
            href={getSalesforceContactLink(providerSalesforceId)}
            target="_blank"
            rel="noopener noreferrer"
            endIcon={<OpenInNew />}
            className={className}
            data-testid="expense-provider-id-button"
        >
            Provider ID
        </Button>
    );
}
